import http from './http-service'
import config from '../config/constant'
import { store } from '../store'

const getLocations = async (data) => {
  try {
    const reqParams = {
      ...data,
    }
    const response = await http.get(config.userActions.getLocations, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getExchangeRatesDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
      userName: 'TEST',
    }
    const response = await http.post(config.userActions.crossCurrencyRate, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getTcDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'TERMS',
      type: 'CORPORATE',
    }
    const response = await http.post(config.userActions.terms, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getComplaintDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.userActions.getComplaintFeedbackCatg, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getFeedbackDetails = async (data) => {
  try {
    const {app} =store.getState()
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
      categoryEmail: app.userDetails.emailId,
      emailId: app.userDetails.emailId,
    }
    const response = await http.post(config.userActions.feedback, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getFAQDetails = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'REGISTUSER',
    }
    const response = await http.post(config.userActions.faq, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const FooterService = {
  getExchangeRatesDetails,
  getFAQDetails,
  getTcDetails,
  getComplaintDetails,
  getFeedbackDetails,
  getLocations,
}

export default FooterService
